import React, { useState, useEffect } from "react";
import { useInstantSearch } from "react-instantsearch";

const translations = {
  en: {
    noResults: "No results found. Try a different search term",
    resultsFound: (num, query) => `${num} results found for "${query}".`,
  },
  fr: {
    noResults: "Aucun résultat trouvé. Essayez un autre terme de recherche",
    resultsFound: (num, query) => `${num} résultats trouvés pour «${query}».`,
  },
};

export default function AriaLive({ numResults }) {
  const { indexUiState } = useInstantSearch();
  const lang = document.documentElement.lang || "en";
  const t = translations[lang] || translations.en;

  const [ariaLiveText, setAriaLiveText] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      const message =
        numResults == 0 || indexUiState.query?.trim() === ""
          ? t.noResults
          : t.resultsFound(numResults, indexUiState.query);
      setAriaLiveText(message);
    }, 1000);

    return () => clearTimeout(timer);
  }, [numResults, indexUiState.query]);

  return (
    <div className="visually-hidden" aria-live="assertive" aria-atomic="true">
      {ariaLiveText}
    </div>
  );
}
